import React from 'react';

import styled, { css } from 'styled-components';
import { StyledGrid } from 'styles/common';

import { generateKey } from 'constants/helper';
import { PlusIcon2, StyledIconV2 } from 'constants/icons';

import { addJobFunctionDimension, addJobFunctionLevel } from 'services/growth/admin';

import { Typography14 } from 'uiToolkit/Typography';

import { useSelectedJobFunctionContext } from '../GrowthSettings';
import { TABLE_LAYOUT_ACTIONS } from './GrowthTableContext';

export const AddDimensionRow = ({ layoutReducerDispatch, dimensions = [], isLoading }) => {
  const { selectedJobFunction } = useSelectedJobFunctionContext();
  const handleClick = () => {
    if (isLoading) return;

    const feUuid = `dim-${generateKey(5)}`;
    layoutReducerDispatch({
      type: TABLE_LAYOUT_ACTIONS.ADD_DIMENSION,
      payload: { insertionIndex: dimensions.length, uuid: feUuid },
    });

    addJobFunctionDimension({
      jobFunctionId: selectedJobFunction.uuid,
      insertAfterLevelId: dimensions?.[dimensions.length - 1]?.uuid ?? null,
    })
      .then((res) => {
        console.log(res);
        layoutReducerDispatch({
          type: TABLE_LAYOUT_ACTIONS.REMOVE_DIMENSION_LOADING,
          payload: { feUuid, beUuid: res?.uuid, name: res?.name },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <StyledGrid
      container
      alignItems="center"
      justify="center"
      style={{
        backgroundColor: 'white',
        minHeight: '3.5rem',
        // maxWidth: 'calc(100% - 3.5rem)', //disabling as add dimension button has been temporarily removed
        borderTop: '1px solid #eaeaea',
        cursor: isLoading ? 'default' : 'pointer',
      }}
      onClick={handleClick}
    >
      <StyledIconV2 size="fixed10px" containerSize="fixed24px" circularOutline color="primary">
        <PlusIcon2 />
      </StyledIconV2>
      <Typography14 color="primary" leftGutter={1.5}>
        Add Dimension
      </Typography14>
    </StyledGrid>
  );
};

export const AddRoleColumn = ({ layoutReducerDispatch, levels = [], isLoading }) => {
  const { selectedJobFunction } = useSelectedJobFunctionContext();
  const handleClick = () => {
    if (isLoading) return;

    const feUuid = `role-${generateKey(5)}`;

    layoutReducerDispatch({
      type: TABLE_LAYOUT_ACTIONS.ADD_ROLE,
      payload: { insertionIndex: levels.length, uuid: feUuid },
    });

    addJobFunctionLevel({
      jobFunctionId: selectedJobFunction.uuid,
      insertAfterLevelId: levels?.[levels.length - 1]?.uuid ?? null,
    }).then((res) => {
      layoutReducerDispatch({
        type: TABLE_LAYOUT_ACTIONS.REMOVE_ROLE_LOADING,
        payload: { feUuid, beUuid: res?.uuid, name: res?.name },
      });
    });
  };
  return (
    <StyledGrid
      container
      alignItems="center"
      justify="center"
      direction="column"
      style={{
        minWidth: '3.5rem',
        maxWidth: '3.5rem',
        backgroundColor: 'white',
        borderLeft: '1px solid #eaeaea',
        cursor: isLoading ? 'default' : 'pointer',
      }}
      onClick={handleClick}
    >
      <StyledIconV2 size="fixed10px" containerSize="fixed24px" circularOutline color="primary">
        <PlusIcon2 />
      </StyledIconV2>
      <Typography14 color="primary" topGutter={1.5} style={{ writingMode: 'vertical-rl' }}>
        Add Role
      </Typography14>
    </StyledGrid>
  );
};

export const StyledDimensionRow = styled.div`
  display: flex;
  width: min-content;

  margin-top: ${(props) => (props.marginTop ? '12px' : 0)};
`;

export const StyledRoleHeaderCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 0.5rem 1rem;
  width: 280px;
  min-height: 60px;

  border: ${(props) => `1px solid ${props.theme.palette.borders.lighterGrey}`};
  border-left-width: 0px;

  background-color: white;

  ${(props) =>
    props.fixed &&
    css`
      width: 240px;
      position: sticky;
      left: 0px;
      z-index: 3;
      border-left-width: 1px;
    `};
`;

export const StyledDimensionColumnCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;

  width: 280px;
  min-height: 240px;

  padding: 1.5rem;
  border: ${(props) => `1px solid ${props.theme.palette.borders.lighterGrey}`};
  border-left-width: 0px;

  background-color: white;

  ${(props) =>
    props.fixed &&
    css`
      width: 240px;
      position: sticky;
      left: 0px;
      z-index: 1;
      border-left-width: 1px;
    `};
`;

const ContentContainer = styled.div`
  border: 1px solid yellow;
  width: 100%;
`;

const DimensionColumn = styled.div`
  border: 1px solid pink;
`;
